import { Row } from "react-bootstrap";
import { styled } from "styled-components";

export const MetaBarWrapper = styled(Row)<{ $topValue: string }>`
  align-items: end;
  padding: 2px;
  background-color: ${(props) => props.theme.colours.primary.white};
  border-bottom: 1px solid ${(props) => props.theme.colours.primary.greyShade};
`;
